export default __webpack_public_path__ + "static/carousel-homepage-5-510682ddffe4ceb20dd4189831e8737e.jpg";